(function () {
  const INITIALIZED_FLAG = 'promoPdpInit';

  function formatMoney(cents, moneyFormat, moneySymbol) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat).replace(/<[^>]+>/g, '').trim();
    }
    return moneySymbol + (cents / 100).toFixed(2);
  }

  function initHero(root) {
    if (!root || root.dataset.heroInitialized === 'true') return;
    root.dataset.heroInitialized = 'true';

    const variantsEl = root.querySelector('[data-variants]');
    if (!variantsEl) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsEl.textContent || '[]');
    } catch (error) {
      console.error('Promo PDP variants parse failed', error);
      return;
    }

    if (!Array.isArray(variants) || variants.length === 0) return;

    const moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    const moneySymbol = root.dataset.moneySymbol || '$';
    const flavorOptionPosition = Math.max(parseInt(root.dataset.flavorOptionPosition || '1', 10), 1);
    const flavorIndex = flavorOptionPosition - 1;
    const servings = Math.max(parseInt(root.dataset.servings || '30', 10), 1);
    const stockTotal = Math.max(parseInt(root.dataset.stockTotal || '5000', 10), 1);
    const stockFallback = Math.max(parseInt(root.dataset.stockFallback || '3600', 10), 0);
    const fallbackVariantTitle = root.dataset.productTitle || '';
    const atcLabel = root.dataset.atcLabel || 'Add to Cart';
    const soldOutLabel = root.dataset.soldOutLabel || 'Sold out';
    const productHandle = root.dataset.productHandle || '';
    const routesRoot =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    const variantInput = root.querySelector('[data-variant-input]');
    const priceCurrentEl = root.querySelector('[data-price-current]');
    const pricePerServeEl = root.querySelector('[data-price-per-serve]');
    const subtitleVariantEl = root.querySelector('[data-variant-title]');
    const atcTextEl = root.querySelector('[data-atc-text]');
    const submitButton = root.querySelector('.product-form__submit');
    const stockRemainingEl = root.querySelector('[data-stock-remaining]');
    const stockTotalEl = root.querySelector('[data-stock-total]');
    const stockBarEl = root.querySelector('[data-stock-bar]');
    const mainImageEl = root.querySelector('[data-main-image]');
    const flavorButtons = Array.from(root.querySelectorAll('.tp-flavor-btn[data-option-value]'));
    const qtyInput = root.querySelector('[data-qty-input]');
    const qtyPlus = root.querySelector('[data-qty-plus]');
    const qtyMinus = root.querySelector('[data-qty-minus]');

    function setStock(variant) {
      let remaining = stockFallback;
      if (variant && variant.inventory_management === 'shopify' && typeof variant.inventory_quantity === 'number') {
        remaining = Math.max(variant.inventory_quantity, 0);
      }

      const pct = Math.max(Math.min((remaining / stockTotal) * 100, 100), 0);

      if (stockRemainingEl) stockRemainingEl.textContent = String(remaining);
      if (stockTotalEl) stockTotalEl.textContent = String(stockTotal);
      if (stockBarEl) stockBarEl.style.width = pct + '%';
    }

    function setVariant(variant) {
      if (!variant) return;

      if (variantInput) {
        variantInput.value = variant.id;
        variantInput.disabled = !variant.available;
      }

      if (subtitleVariantEl) {
        subtitleVariantEl.textContent = variant.title && variant.title !== 'Default Title' ? variant.title : fallbackVariantTitle;
      }

      if (priceCurrentEl) {
        priceCurrentEl.textContent = formatMoney(variant.price, moneyFormat, moneySymbol);
      }

      if (pricePerServeEl) {
        pricePerServeEl.textContent =
          formatMoney(Math.round(variant.price / servings), moneyFormat, moneySymbol) + ' per serve';
      }

      if (submitButton && atcTextEl) {
        if (variant.available) {
          submitButton.removeAttribute('disabled');
          atcTextEl.textContent = atcLabel + ' — ' + formatMoney(variant.price, moneyFormat, moneySymbol);
        } else {
          submitButton.setAttribute('disabled', 'disabled');
          atcTextEl.textContent = soldOutLabel;
        }
      }

      if (variant.featured_image && variant.featured_image.src && mainImageEl && mainImageEl.tagName === 'IMG') {
        mainImageEl.src = variant.featured_image.src;
      }

      setStock(variant);

      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', currentUrl.toString());

      flavorButtons.forEach(function (button) {
        const matches = variant.options && variant.options[flavorIndex] === button.dataset.optionValue;
        button.classList.toggle('is-active', !!matches);
      });

      document.dispatchEvent(
        new CustomEvent('tp:variant:change', {
          detail: {
            variant: variant,
          },
        })
      );
    }

    function getCurrentVariant() {
      const currentId = Number(variantInput && variantInput.value);
      return variants.find(function (variant) {
        return variant.id === currentId;
      }) || variants[0] || null;
    }

    function refreshLiveInventory() {
      if (!productHandle) return;

      fetch(routesRoot + 'products/' + encodeURIComponent(productHandle) + '.js', {
        credentials: 'same-origin',
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Inventory refresh failed');
          return response.json();
        })
        .then(function (productData) {
          if (!productData || !Array.isArray(productData.variants)) return;

          const inventoryById = {};
          productData.variants.forEach(function (variant) {
            inventoryById[variant.id] = {
              inventory_quantity: variant.inventory_quantity,
              inventory_management: variant.inventory_management,
              available: variant.available,
            };
          });

          variants.forEach(function (variant) {
            const live = inventoryById[variant.id];
            if (!live) return;
            variant.inventory_quantity = live.inventory_quantity;
            variant.inventory_management = live.inventory_management;
            variant.available = live.available;
          });

          setVariant(getCurrentVariant());
        })
        .catch(function () {
          // Keep last known numbers if fetch fails.
        });
    }

    flavorButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.dataset.available !== 'true') return;

        const optionValue = button.dataset.optionValue;
        const candidates = variants.filter(function (variant) {
          return variant.options && variant.options[flavorIndex] === optionValue;
        });
        const next = candidates.find(function (variant) {
          return variant.available;
        }) || candidates[0];
        if (!next) return;

        setVariant(next);
      });
    });

    if (qtyInput && qtyPlus && qtyMinus) {
      qtyPlus.addEventListener('click', function () {
        const next = Math.max(1, parseInt(qtyInput.value || '1', 10) + 1);
        qtyInput.value = String(next);
      });

      qtyMinus.addEventListener('click', function () {
        const next = Math.max(1, parseInt(qtyInput.value || '1', 10) - 1);
        qtyInput.value = String(next);
      });

      qtyInput.addEventListener('change', function () {
        const normalized = Math.max(1, parseInt(qtyInput.value || '1', 10));
        qtyInput.value = String(normalized);
      });
    }

    root.querySelectorAll('.tp-thumb[data-image-src]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        const imageSrc = thumb.getAttribute('data-image-src');
        if (mainImageEl && mainImageEl.tagName === 'IMG' && imageSrc) {
          mainImageEl.src = imageSrc;
        }

        root.querySelectorAll('.tp-thumb').forEach(function (item) {
          item.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      });
    });

    setVariant(getCurrentVariant());
    refreshLiveInventory();
    window.setInterval(refreshLiveInventory, 30000);

    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (event) {
        const variantId = Number(event && event.productVariantId);
        if (!variantId) return;

        const matched = variants.find(function (variant) {
          return variant.id === variantId;
        });
        if (!matched) return;

        const qty = Math.max(1, parseInt((qtyInput && qtyInput.value) || '1', 10));
        if (matched.inventory_management === 'shopify' && typeof matched.inventory_quantity === 'number') {
          matched.inventory_quantity = Math.max(0, matched.inventory_quantity - qty);
        }
        setVariant(getCurrentVariant());
      });
    }
  }

  function initFaqToggles(scope) {
    (scope || document).querySelectorAll('[data-faq-toggle]').forEach(function (toggle) {
      if (toggle.dataset.faqInitialized === 'true') return;
      toggle.dataset.faqInitialized = 'true';

      toggle.addEventListener('click', function () {
        const item = toggle.closest('.tp-faq-item');
        if (!item) return;
        item.classList.toggle('is-open');
      });
    });
  }

  let revealObserver;
  function initRevealObserver(scope) {
    if (!('IntersectionObserver' in window)) return;

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) entry.target.classList.add('is-visible');
          });
        },
        { threshold: 0.15 }
      );
    }

    (scope || document).querySelectorAll('.tp-reveal').forEach(function (element) {
      if (element.dataset.revealObserved === 'true') return;
      element.dataset.revealObserved = 'true';
      revealObserver.observe(element);
    });
  }

  function initCtaScroll(scope) {
    (scope || document).querySelectorAll('[data-scroll-to-atc]').forEach(function (button) {
      if (button.dataset.scrollInitialized === 'true') return;
      button.dataset.scrollInitialized = 'true';

      button.addEventListener('click', function () {
        const selector = button.getAttribute('data-target-selector') || '.tp-pdp-hero .tp-product-form';
        const target = document.querySelector(selector);
        if (!target) return;
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  }

  function initStickyAtc(scope) {
    (scope || document).querySelectorAll('[data-tp-sticky-atc]').forEach(function (root) {
      if (root.dataset.stickyInitialized === 'true') return;
      root.dataset.stickyInitialized = 'true';

      const bar = root.querySelector('.tp-sticky-atc');
      const priceEl = root.querySelector('[data-sticky-price]');
      const variantEl = root.querySelector('[data-sticky-variant]');
      const submitButton = root.querySelector('[data-sticky-submit]');
      const variantsEl = root.querySelector('[data-sticky-variants]');
      if (!bar || !submitButton || !variantsEl) return;

      const enableDesktop = root.dataset.enableDesktop === 'true';
      const enableMobile = root.dataset.enableMobile === 'true';
      const moneyFormat = root.dataset.moneyFormat || '${{amount}}';
      const moneySymbol = root.dataset.moneySymbol || '$';
      const atcLabel = root.dataset.atcLabel || 'Add to Cart';
      const soldOutLabel = root.dataset.soldOutLabel || 'Sold out';
      const fallbackProductTitle = root.dataset.productTitle || '';

      let variants = [];
      try {
        variants = JSON.parse(variantsEl.textContent || '[]');
      } catch (error) {
        console.error('Promo Sticky ATC variants parse failed', error);
        return;
      }

      if (!Array.isArray(variants) || variants.length === 0) return;

      let currentVariant = variants[0];

      function isMobile() {
        return window.matchMedia('(max-width: 989px)').matches;
      }

      function getHeroVariantInput() {
        return document.querySelector('.tp-pdp-hero [data-variant-input]');
      }

      function getHeroSubmitButton() {
        return document.querySelector('.tp-pdp-hero .product-form__submit');
      }

      function setVariant(variant) {
        if (!variant) return;
        currentVariant = variant;

        if (priceEl) {
          priceEl.textContent = formatMoney(variant.price, moneyFormat, moneySymbol);
        }

        if (variantEl) {
          variantEl.textContent = variant.title && variant.title !== 'Default Title' ? variant.title : fallbackProductTitle;
        }

        if (variant.available) {
          submitButton.removeAttribute('disabled');
          submitButton.textContent = atcLabel + ' — ' + formatMoney(variant.price, moneyFormat, moneySymbol);
        } else {
          submitButton.setAttribute('disabled', 'disabled');
          submitButton.textContent = soldOutLabel;
        }
      }

      function syncFromHeroVariant() {
        const heroInput = getHeroVariantInput();
        if (!heroInput) return;
        const heroVariantId = Number(heroInput.value);
        const matched = variants.find(function (variant) {
          return variant.id === heroVariantId;
        });
        if (matched) setVariant(matched);
      }

      function updateVisibility() {
        const enabledForViewport = isMobile() ? enableMobile : enableDesktop;
        if (!enabledForViewport) {
          bar.classList.remove('is-visible');
          return;
        }

        const heroBlock = document.querySelector('.tp-pdp-hero .tp-hero');
        if (!heroBlock) {
          bar.classList.add('is-visible');
          return;
        }

        const heroBottom = heroBlock.getBoundingClientRect().bottom;
        const shouldShow = heroBottom < window.innerHeight * 0.5;
        bar.classList.toggle('is-visible', shouldShow);
      }

      submitButton.addEventListener('click', function () {
        if (!currentVariant || !currentVariant.available) return;

        const heroInput = getHeroVariantInput();
        if (heroInput) heroInput.value = String(currentVariant.id);

        const heroSubmit = getHeroSubmitButton();
        if (heroSubmit && !heroSubmit.disabled) {
          heroSubmit.click();
          return;
        }
      });

      document.addEventListener('tp:variant:change', function (event) {
        const nextVariant = event && event.detail && event.detail.variant;
        if (!nextVariant) return;

        const matched = variants.find(function (variant) {
          return variant.id === nextVariant.id;
        });
        setVariant(matched || nextVariant);
      });

      syncFromHeroVariant();
      setVariant(currentVariant);
      updateVisibility();

      window.addEventListener('scroll', updateVisibility, { passive: true });
      window.addEventListener('resize', updateVisibility);
    });
  }

  function initVsCarousels(scope) {
    (scope || document).querySelectorAll('[data-vs-carousel]').forEach(function (carousel) {
      if (carousel.dataset.vsInitialized === 'true') return;
      carousel.dataset.vsInitialized = 'true';

      const track = carousel.querySelector('[data-vs-track]');
      if (!track) return;

      const slides = Array.from(track.children);
      const prev = carousel.querySelector('[data-vs-prev]');
      const next = carousel.querySelector('[data-vs-next]');
      const dots = Array.from(carousel.querySelectorAll('[data-vs-dot]'));
      if (slides.length === 0) return;

      let index = 0;

      function update() {
        track.style.transform = 'translateX(-' + index * 100 + '%)';

        dots.forEach(function (dot, dotIndex) {
          dot.classList.toggle('is-active', dotIndex === index);
        });

        if (prev) prev.disabled = index === 0;
        if (next) next.disabled = index === slides.length - 1;
      }

      if (prev) {
        prev.addEventListener('click', function () {
          index = Math.max(0, index - 1);
          update();
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          index = Math.min(slides.length - 1, index + 1);
          update();
        });
      }

      dots.forEach(function (dot, dotIndex) {
        dot.addEventListener('click', function () {
          index = dotIndex;
          update();
        });
      });

      window.addEventListener('resize', update);
      update();
    });
  }

  function init(scope) {
    const container = scope || document;
    container.querySelectorAll('.tp-pdp-hero[data-section-id]').forEach(initHero);
    initFaqToggles(container);
    initRevealObserver(container);
    initCtaScroll(container);
    initVsCarousels(container);
    initStickyAtc(container);
  }

  function onReady() {
    if (document.body.dataset[INITIALIZED_FLAG] === 'true') return;
    document.body.dataset[INITIALIZED_FLAG] = 'true';

    init(document);

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
